import { Persistable, property, Remoteable, Supertype, supertypeClass } from '@haventech/amorphic';

@supertypeClass({ toClient: true, toServer: true })
export class Exchange1035 extends Remoteable(Persistable(Supertype)) {
  public static readonly EXPECTED_ARRIVAL_DEFAULT_MONTHS: number = 3;

  @property({ comment: 'Cash value to be transferred from existing policy' })
  cashValueTransfer: number;

  @property({ comment: 'Amount that has been put into existing policy' })
  costBasis: number;

  @property({ comment: 'Type of existing policy' })
  policyType: string;

  @property({ comment: 'Destination the cash value transfer will be sent to' })
  applyTowards: string;

  @property({ comment: 'Expected arrival of the cash value transfer' })
  expectedArrival: number;

  @property({ comment: 'Is existing policy a MEC' })
  isMec: boolean;

  @property({ comment: 'The date when the 1035 funds were received' })
  dateFundsReceived: Date;

  constructor() {
    super();
  }

  static new(
    cashValueTransfer: number,
    costBasis: number,
    policyType: string,
    applyTowards: string,
    expectedArrival: number,
    isMec: boolean
  ) {
    return new Exchange1035().init(cashValueTransfer, costBasis, policyType, applyTowards, expectedArrival, isMec);
  }

  init(
    cashValueTransfer: number,
    costBasis: number,
    policyType: string,
    applyTowards: string,
    expectedArrival: number,
    isMec: boolean
  ) {
    this.cashValueTransfer = cashValueTransfer;
    this.costBasis = costBasis;
    this.policyType = policyType;
    this.applyTowards = applyTowards;
    this.expectedArrival = expectedArrival;
    this.isMec = isMec;
    return this;
  }

  /**
   * This function will set (a null) cost basis to be equal to the cash value transfer if the latter is not null.
   */
  setCostBasisToCashValueTransfer(): void {
    if (this.cashValueTransfer && !this.costBasis) {
      this.costBasis = this.cashValueTransfer;
    }
  }
}
